import React, { useState, useEffect } from 'react'
import FlexView from 'react-flexview/lib'
import {
  Grid,
  TextField,
  useMediaQuery,
  Button,
  InputAdornment,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@material-ui/core'
import { useForm } from 'react-hook-form'
import {
  EventEmitterService,
  EventKey,
} from '../../services/EventEmitterService'
import { awaitWithLoading } from '../../services/utils'
import { SessionContextStore } from '../../context/SessionContext'
import { UserApi } from '../../api/user.api'
import { OptionalTag } from '../Core/OptionalTag'

import dayjs from 'dayjs'
import './ManageProfile.scss'

var classNames = require('classnames')

export const ApproveRefferalRequest = (props) => {
  const { register, getValues } = useForm({ mode: 'onChange' })
  const { declinationDate, reason, comment, payload } = props
  const [declined, setDeclined] = useState(props.declined)
  const [allowed, setAllowed] = useState(props.allowed)
  const [approvedBy, setApprovedBy] = useState('Global')

  useEffect(() => {
    setDeclined(props.declined)
  }, [props.declined])

  const returnDeclinationReason = (propery) => {
    switch (propery) {
      case 'HasAccidents':
        return 'Has accidents'
      case 'HasViolations':
        return 'Has violations'
      case 'FlightSchoolNameNotSupported':
        return 'Flight school name not supported'
      case 'IsStateAllow':
        return 'State not allow'
      default:
        return propery
    }
  }

  const onApprove = async () => {
    let res = await awaitWithLoading(
      UserApi.manageDeclinations({
        comment: getValues()['allow_comment'],
        property: reason,
        type: 'Allow',
        approved_by: approvedBy,
      })
    )
    if (res.ok) {
      setAllowed(true)
      props.closeReffedRequest(props)
    } else {
      EventEmitterService.dispatch(EventKey.ShowError, res)
    }
  }

  const onDecline = async () => {
    let res = await awaitWithLoading(
      UserApi.manageDeclinations({
        comment: getValues()['allow_comment'],
        property: reason,
        type: 'Decline',
      })
    )
    if (res.ok) {
      setDeclined(true)
      props.closeReffedRequest(props)
    } else {
      EventEmitterService.dispatch(EventKey.ShowError, res)
    }
  }

  return (
    <FlexView>
      <FlexView column>
        <Grid className="margin-bottom-basic" spacing={8}>
          <Grid item sm={6}>
            <b>Date :</b> {new Date(declinationDate).toLocaleDateString()}
          </Grid>
          <Grid className="margin-bottom-basic" item sm={9}>
            <b>Reason :</b> {returnDeclinationReason(reason)} <br />
            <b>Details:</b>
            <ul>
              {Object.entries(payload).map(([key, value]) => (
                <li key={key}>
                  {key}:{' '}
                  {key === 'Date' ? dayjs(value).format('YYYY, MMMM') : value}
                </li>
              ))}
            </ul>
          </Grid>
          <Grid item md={15}>
            {allowed ? (
              <div className="approved-div">
                <img
                  className="approved-img"
                  src={process.env.PUBLIC_URL + '/assets/v-sign.png'}
                />
                <div className="text">This refferal was approved</div>
              </div>
            ) : declined ? (
              <div className="declined-div">
                <img
                  className="declined-img"
                  src={process.env.PUBLIC_URL + '/assets/x-sign.png'}
                />
                <div className="text">This refferal was declined</div>
              </div>
            ) : (
              <TextField
                inputRef={register({ required: false })}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <OptionalTag />{' '}
                    </InputAdornment>
                  ),
                }}
                className="lightgrayblue"
                placeholder="Do you have any comments for this request?"
                style={{ width: '500px' }}
                multiline
                rows={5}
                variant="outlined"
                name="allow_comment"
              />
            )}
          </Grid>
        </Grid>
        {!allowed && !declined && (
          <FlexView>
            <RadioGroup
              className="margin-bottom-basic"
              value={approvedBy}
              onChange={(e) => setApprovedBy(e.target.value)}>
              <FlexView>
                <FormControlLabel
                  key="Global"
                  value="Global"
                  control={<Radio color="primary" />}
                  label={<div className="text-small">Approved By Global</div>}
                />
              </FlexView>
              <FlexView>
                <FormControlLabel
                  key="Voom"
                  value="Voom"
                  control={<Radio color="primary" />}
                  label={<div className="text-small">Approved Internally</div>}
                />
              </FlexView>
            </RadioGroup>
          </FlexView>
        )}
      </FlexView>
      <Grid item sm={1} md={2}>
        {!allowed && !declined && (
          <button
            onClick={onApprove}
            className="approve-button margin-bottom-basic margin-top-large">
            {' '}
            Approve{' '}
          </button>
        )}
        {!allowed && !declined && (
          <button
            onClick={onDecline}
            className="decline-button margin-bottom-basic">
            {' '}
            Decline{' '}
          </button>
        )}
      </Grid>
    </FlexView>
  )
}
